import Section, { type SectionProps } from './Section';

export type { SectionProps };
export default Section;
